<script>
  import options from './FilterComponent.options'
  export default options
</script>

<template>
<div>
  <FilterControls v-if="mobileDrawerContext" :mobileDrawerContext="mobileDrawerContext" />
  <article class="nlx-filter-component" id="filterbar">
    <template v-for="(group,key) in facets" :key="key">
      <fieldset class="nlx-filter-component__filter">
              <button class="nlx-filter-component__filter-toggle" 
                :id="`filterbutton${key}`" 
                :area-controls="`filtergroup${key}`" 
                :aria-expanded="!!(expandedFilters[key])"
                @click="expandFilter(key)">
                  {{group.displayName}} 
                  <span class="nlx-filter-component__filter-toggle__count">{{group.count}}</span>
                  <div class="nlx-filter-component__chevron">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#000000" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path></svg>
                  </div>
              </button>
              <div class="nlx-filter-component__filter-content" 
                :id="`filtergroup${key}`" 
                :aria-labelledby="`filterbutton${key}`"
                role="region" >

                <template v-for="(facet,facetKey) in group.facets" :key="facetKey">
                  <input class="nlx-filter-component__filter-checkbox" 
                    :id="`filter${key}field${facetKey}`" 
                    :checked="facet.selected"
                    type="checkbox">
                  <label class="nlx-filter-component__filter-checkbox-label" 
                    :for="`filter${key}field${facetKey}`"
                    @click.prevent="selectFacet(group,facet)">
                    {{facet.displayName}}
                    <span class="nlx-filter-component__filter-toggle__count">{{facet.count}}</span>
                  </label>
                </template>
              </div>
      </fieldset>
    </template>

  </article>
  <template v-if="mobileDrawerContext">
    <div class="nlx-filter-component__mobile-button">
      <button @click="closeMobileFilter" class="nlx-button">{{getLabel('apply_filters')}} ({{filterCount}}) </button>
    </div>
  </template>
</div>
</template>
